import {useCallback, useEffect, useState} from "preact/compat";

// Deprecated, but leaving it here in case we need to switch back to it
// const CTAs = [
//     "🕒 rápido",
//     "🧪 prático",
//     "🪽 simples"
// ];

const CTAs = [
    "rápido",
    "prático",
    "simples"
];

export const useFirstSlide = (props) => {
    // Destructured props
    const {} = props;

    // State to control the current cta to be rendered
    const [currentCta, setCurrentCta] = useState(0);

    // Effect to dispatch the interval
    useEffect(() => {
        setInterval(() => {
            setCurrentCta(prevState => {
                return prevState < CTAs.length - 1 ? prevState + 1 : 0;
            });
        }, 1800);
    }, []);

    return {
        CTAs,
        currentCta
    }
}
